import { useStore } from '@bluheadless/ui-logic/src/providers/store'
import { mediaUrl } from '@bluheadless/ui-logic/src/assets'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import NextHead from 'next/head'

const Organization = () => {
	const store = useStore()
	const {
		richSnippets: {
			organization: { logo },
		},
		seoMarkup: {
			name,
			alternateName,
			email,
			streetAddress,
			addressLocality,
			addressCountry,
			addressRegion,
			postalCode,
			vatID,
			sameAs,
		} = {},
		seoMeta: { title },
		siteTelephone,
	} = useConfig()

	return (
		<>
			<NextHead>
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: JSON.stringify({
							'@context': 'https://schema.org',
							'@type': 'Organization',
							url: store.uri,
							name: name ?? title,
							alternateName,
							logo: logo ? mediaUrl(logo) : '',
							image: logo ? mediaUrl(logo) : '',
							email,
							telephone: siteTelephone,
							sameAs,
							address: {
								'@type': 'PostalAddress',
								streetAddress,
								addressLocality,
								addressRegion,
								postalCode,
								addressCountry,
							},
							vatID,
							brand: {
								'@type': 'Brand',
								name: name ?? title,
								alternateName,
								logo: logo ? mediaUrl(logo) : '',
							},
						}),
					}}
				/>
			</NextHead>
		</>
	)
}

export default Organization
